export const FETCH_BUILDING_FEATURES_SUCCESS = "FETCH_BUILDING_FEATURES_SUCCESS";
